import {StyleSheet, Text, View, Switch, Pressable} from 'react-native';
import React, {useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {useNavigation, useTheme} from "@react-navigation/native";
import {useTranslation} from "react-i18next";
import Check from "./Check";

export const LangItem = (props) => {
    const lang = props.lang;
    const currentLang = useSelector(state => state.lang);
    const dispatch = useDispatch();
    const theme= useTheme();
    const navigation= useNavigation();
    const {t, i18n} = useTranslation();


    const styles = StyleSheet.create({
        langItemWrapper: {
            width: '100%',
            maxWidth: 800,
            padding: 12,
            display:'flex',
            flexDirection:'row',
            flexWrap:'nowrap',
            fontFamily: 'Roboto-Regular',
            backgroundColor:theme.colors.scheme[4],
            marginBottom:8,
            borderRadius:24,
            borderWidth:2,
            borderColor:theme.colors.scheme[5]
        },
        settingsTitle: {
            display:'flex',
            flexDirection:'row',
            alignItems:'center',
            paddingHorizontal:12,
            width:'90%'
        }
    });
    return(
        <View style={styles.langItemWrapper}>
            <Pressable style={styles.settingsTitle} onPress={() => {
                dispatch({type: 'CHANGE_LANG', payload: {lang: lang}})
                navigation.goBack()
            }}>
                <Check title="Check" id={0} check={currentLang === lang} onPress={() => {
                    dispatch({type: 'CHANGE_LANG', payload: {lang: lang}})
                    navigation.goBack()
                }} />
                <Text style={{marginLeft:12,fontWeight:'bold', color:theme.colors.scheme[2]}}>{t('lang.list.'+lang)}</Text>
            </Pressable>
        </View>
    );
}